import styles from './SCSS/StandalonePageWrapper.module.scss';

const StandalonePageWrapper = (props) => (
  <div className={styles.standalonePage}>{props.children}</div>
);

export default StandalonePageWrapper;
